export enum SupportSideBarTabs {
	Help,
	Message
}
